import { render, staticRenderFns } from "./ProductVarianceSelecter.vue?vue&type=template&id=161ec906"
import script from "./ProductVarianceSelecter.vue?vue&type=script&lang=js"
export * from "./ProductVarianceSelecter.vue?vue&type=script&lang=js"
import style0 from "./ProductVarianceSelecter.vue?vue&type=style&index=0&id=161ec906&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports